import {
  DURING_STAY_SURVEY_GET_ANSWER,
  DURING_STAY_SURVEY_GET_ANSWER_ERROR,
  DURING_STAY_SURVEY_GET_ANSWER_SUCCESS,
  DURING_STAY_SURVEY_SEND_ANSWER,
  DURING_STAY_SURVEY_SEND_ANSWER_ERROR,
  DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS
} from './../../actions/const';

import CustomerJourneySource from './../../sources/CustomerJourneySource';

const initialState = {
  status: null,
  loading: false,
  error: null,
  submitting: false
};

function reducer(state = initialState, action) {
  const nextState = Object.assign({}, state);

  switch (action.type) {
    case DURING_STAY_SURVEY_SEND_ANSWER: {
      nextState.submitting = true;
      nextState.error = null;
      nextState.status = null;
      CustomerJourneySource.duringStaySurvey_sendAnswer(
        action.comment, action.vote, action.token, action.lang, action.context);
      return nextState;
    }
    case DURING_STAY_SURVEY_SEND_ANSWER_SUCCESS: {
      nextState.submitting = false;
      nextState.status = 'DONE';
      nextState.error = null;
      return nextState;
    }
    case DURING_STAY_SURVEY_SEND_ANSWER_ERROR: {
      nextState.submitting = false;
      nextState.error = 'duringStaySurvey.error';
      return nextState;
    }
    case DURING_STAY_SURVEY_GET_ANSWER: {
      nextState.loading = true;
      nextState.status = null;
      nextState.error = null;
      CustomerJourneySource.duringStaySurvey_getAnswer(
        action.token, action.lang, action.context);
      return nextState;
    }
    case DURING_STAY_SURVEY_GET_ANSWER_SUCCESS: {
      nextState.loading = false;
      nextState.status = action.data.status;
      nextState.error = null;
      return nextState;
    }
    case DURING_STAY_SURVEY_GET_ANSWER_ERROR: {
      nextState.loading = false;
      nextState.status = null;
      nextState.error = 'duringStaySurvey.error';
      return nextState;
    }
    default: {
      return state;
    }
  }
}

module.exports = reducer;



// WEBPACK FOOTER //
// ./reducers/customerJourney/duringStaySurvey.js